import { render, staticRenderFns } from "./TheBreadcrumbs.vue?vue&type=template&id=4f2d89c0&"
import script from "./TheBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./TheBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./TheBreadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VIcon})
